import { render, staticRenderFns } from "./VoiceSelector.vue?vue&type=template&id=4bfef43b&scoped=true&"
import script from "./VoiceSelector.vue?vue&type=script&lang=js&"
export * from "./VoiceSelector.vue?vue&type=script&lang=js&"
import style0 from "./VoiceSelector.vue?vue&type=style&index=0&id=4bfef43b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfef43b",
  null
  
)

export default component.exports